import Pusher from "pusher-js";
import NotificationAPI from './notification_api';
import Ajax from "../../shared/ajax";

class PushNotificationHandler {
  constructor(config) {
    const { args, channel, key, doNotDisturbEnabled } = config.pushNotificationConfig;
    const pusherClient = new Pusher(key, {
      authEndpoint: config.urlConfig.notificationAuth,
      auth: { headers: { 'X-CSRF-Token': Ajax.getCsrfToken() } },
      ...args });
    this.channel = pusherClient.subscribe(channel);
    this.notificationAPI = new NotificationAPI(config.urlConfig);
    this.doNotDisturbEnabled = doNotDisturbEnabled;
  }

  _getNotification(callBack) {
    return (data) => {
      this.notificationAPI.get(data.id)
        .then((response) => callBack(response))
        .catch(() => {});
    };
  }

  subscribeToEvent(event, callBack) {
    this.channel.bind(event, this._getNotification(callBack));
  }
}

export default PushNotificationHandler;
